import ChangeEmailDialogModule from './change-email.module'

export default ChangeEmailDialogModule
